import { SidebarComponent } from './core/sidebar/sidebar.component';
import { HeaderService } from './core/header/header.service';
import { HeaderComponent } from './core/header/header.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { RegistroModule } from './registro/registro.module';
import { SharedModule } from './shared/shared.module';
import { ModalConsultaRegistroComponent } from './shared/modal/modal-consulta-registro/modal-consulta-registro.component';
import { ModalCadastroContadorComponent } from './shared/modal/modal-cadastro-contador/modal-cadastro-contador.component'
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatePTParserFormatter } from './shared/ngb-date-pt-parser-formatter/NgbDatePTParserFormatter';
import { NgxMaskModule } from 'ngx-mask';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RegistroComponent } from './registro/registro.component';
import { RegistroContadorComponent } from './registro-contador/registro-contador.component';
import { DataTablesModule } from 'angular-datatables';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalConfirmaExContadorComponent} from './shared/modal/modal-confirma-ex-contador/modal-confirma-ex-contador.component';
import { ModalConfirmaLimparCamposComponent } from './shared/modal/modal-confirma-limpar-campos/modal-confirma-limpar-campos.component';
import { ModalExibirContadorComponent } from './shared/modal/modal-exibir-contador/modal-exibir-contador.component';
import { ModalEditarContadorComponent } from './shared/modal/modal-editar-contador/modal-editar-contador.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ModalSelecaoDBEComponent } from './shared/modal/modal-selecao-dbe/modal-selecao-dbe.component';


registerLocaleData(localePt);
import { from } from 'rxjs';
import { FooterComponent } from './core/footer/footer.component';
import { TokenService } from './token.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RegistroJucespComponent } from './registro-jucesp/registro-jucesp.component';
import { ModalRegistroJucespComponent } from './shared/modal/modal-registro-jucesp/modal-registro-jucesp.component';
import { ErrorHandlerService } from './errorHandler.service';
import { HttpClientService } from './services/http-client.service';
import { ModalLogoutComponent } from './shared/modal/modal-logout/modal-logout.component';
import { InscricoesTributariasComponent } from './inscricoes-tributarias/inscricoes-tributarias.component';

@NgModule({
  declarations: [
    AppComponent,
    RegistroContadorComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    DashboardComponent,
    RegistroComponent,
    RegistroJucespComponent,
    InscricoesTributariasComponent
  ],
  imports: [
    BrowserModule,
    DataTablesModule.forRoot(),
    AppRoutingModule,
    CoreModule,
    MDBBootstrapModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgbModule.forRoot(),
    FontAwesomeModule,
    DashboardModule,
    RegistroModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NgHttpLoaderModule
  ],
  providers: [
    NgbActiveModal,
    { provide: NgbDatePTParserFormatter, useClass: NgbDatePTParserFormatter },
    { provide: LOCALE_ID, useValue: 'pt-br' },
    HeaderService,
    TokenService,
    ErrorHandlerService,
    HttpClientService
  ],
  entryComponents: [
    ModalConsultaRegistroComponent,
    ModalCadastroContadorComponent,
    ModalCadastroContadorComponent,
    ModalConfirmaLimparCamposComponent,
    ModalConfirmaExContadorComponent,
    ModalExibirContadorComponent,
    ModalEditarContadorComponent,
    ModalRegistroJucespComponent,
    ModalLogoutComponent,
    ModalSelecaoDBEComponent
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }
